/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Table from "react-bootstrap/Table";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";

import presidentsArray from "assets/texts/presidents.json";

function PresidentsSite() {
  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Vorstände" />
      {/* <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Vorstände
        </MKTypography>
      </MKBox> */}
      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          pt: 8,
          pb: 8,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Table responsive className="noBorder">
            <tbody>
              <tr>
                <td max-width={200}>
                  <MKTypography variant="h5" color="text">
                    Jahr
                  </MKTypography>
                </td>
                <td>
                  <MKTypography variant="h5" color="text">
                    Vorstand
                  </MKTypography>
                </td>
                <td>
                  <MKTypography variant="h5" color="text">
                    Beschreibung
                  </MKTypography>
                </td>
              </tr>
              {presidentsArray.map((row) => (
                <tr key={row.time}>
                  <td max-width={200}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      dangerouslySetInnerHTML={{ __html: row.time }}
                    />
                  </td>
                  <td>
                    <MKTypography
                      variant="body2"
                      color="text"
                      dangerouslySetInnerHTML={{ __html: row.president }}
                    />
                  </td>
                  <td>
                    <MKTypography
                      variant="body2"
                      color="text"
                      dangerouslySetInnerHTML={{ __html: row.text }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default PresidentsSite;
